// サムネイル
var sliderThumbnail = new Swiper("#productSlideContents .slider-thumbnail", {
  slidesPerView: 4, // サムネイルの枚数
  spaceBetween: 12,
  freeMode: true,
  watchSlidesProgress: true,
  grabCursor: true,
});
// スライダー
var slider = new Swiper("#productSlideContents .slider", {
  loop: true,
  // 前後の矢印
  navigation: {
    nextEl: "#productSlideContents .swiper-button-next",
    prevEl: "#productSlideContents .swiper-button-prev",
  },
  thumbs: {
    swiper: sliderThumbnail,
  },
});